"use client";

import { ArrowLeft, List } from "lucide-react";
import { useState } from "react";

import RenderIf from "@/app/_module/components/RenderIf";
import { Button } from "@/app/_module/components/ui/button";
import {
  Dialog,
  DialogTrigger,
  ResponsiveDialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/app/_module/components/ui/dialog";

import ImportedLeadsList from "./ImportedLeadsList";

const ImportLeadsListModal = function ({
  resetPrevModal,
}: {
  resetPrevModal?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [isViewingDetails, setIsViewingDetails] = useState(false);

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button
          className="transition-all duration-200 hover:scale-105"
          onClick={resetPrevModal}
          size="sm"
          variant="outline"
        >
          <List className="h-4 w-4 mr-2" />
          Leads Lists
        </Button>
      </DialogTrigger>

      <ResponsiveDialogContent size="3xl" className="m-lists-modal max-h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <div className="flex items-start gap-3">
            <RenderIf condition={isViewingDetails}>
              <Button
                className="mt-0.5"
                onClick={() => setIsViewingDetails(false)}
                size="sm"
                variant="outline"
              >
                <ArrowLeft className="h-4 w-4 mr-1.5" />
                Back
              </Button>
            </RenderIf>

            <div className="flex-1 min-w-0">
              <DialogTitle className="flex items-center gap-2 text-lg font-semibold text-gray-900">
                <List className="h-5 w-5 text-gray-600" />
                <RenderIf condition={isViewingDetails}>
                  Import Details
                </RenderIf>
                <RenderIf condition={!isViewingDetails}>
                  Leads Lists
                </RenderIf>
              </DialogTitle>
              <DialogDescription className="mt-1">
                <RenderIf condition={isViewingDetails}>
                  File contents, row-level outcomes, and activation history for this import.
                </RenderIf>
                <RenderIf condition={!isViewingDetails}>
                  Review previously imported CSVs, see row counts, and activate pending batches into your pipeline.
                </RenderIf>
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="flex-1 overflow-hidden flex flex-col pt-2">
          <ImportedLeadsList
            isViewingDetails={isViewingDetails}
            setIsViewingDetails={setIsViewingDetails}
            setOpen={setOpen}
          />
        </div>
      </ResponsiveDialogContent>
    </Dialog>
  );
};

export default ImportLeadsListModal;
